import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.FlashDismiss = createClass({
  mixins: [CssClassMixin],
  propTypes: {
    type: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func
  },

  getInitialState: function() {
    return {
      themeClassKey: 'flash.dismiss flash.' + this.props.type + '.content'
    };
  },

  render: function() {
    return (
      <div className={this.className()} onClick={this.props.onClick}>
        <Icon type="close" />
      </div>
    );
  }
});
